import suncalc from 'suncalc';

export type SunInfo = {
  solarNoon: number | null;
  nadir: number | null;
  sunrise: number | null;
  sunset: number | null;
  sunriseEnd: number | null;
  sunsetStart: number | null;
  dawn: number | null;
  dusk: number | null;
  nauticalDawn: number | null;
  nauticalDusk: number | null;
  nightEnd: number | null;
  night: number | null;
  goldenHourEnd: number | null;
  goldenHour: number | null;
};

export type SunInfoParams = {
  timestamp?: number;
  latitude: number;
  longitude: number;
};

const getInfo = ({timestamp, latitude, longitude}: SunInfoParams): SunInfo => {
  const rawTimes = suncalc.getTimes(
    timestamp ? new Date(timestamp * 1000) : new Date(),
    latitude,
    longitude,
  );
  const info = {} as SunInfo;
  Object.entries(rawTimes).forEach(([k, v]) => {
    info[k] = v instanceof Date ? Math.floor(v.getTime() / 1000) : null;
  });
  return info;
};

export {getInfo};
